// The Renatural — Showroom Scheduler v4
// Fixes: required new/returning, multi-select what's on your mind, title case pills,
//        calendar + time on dedicated step 4, review + pay on step 5
// Real Google Calendar availability via Google Apps Script
// Payment via Shopify checkout — calendar event created on order_paid webhook
// Klaviyo Consultation Booked event fires server-side via Apps Script

(function () {
  'use strict';

  // ── Config ─────────────────────────────────────────────────────────────────
  var APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwRRWdkWKtb9ZE8wmnv3BkdmWHshqzR3f75MH6sE_XveMVMvJMvjS1roR442DSpUZWL6w/exec';

  // Shopify variant IDs
  var VARIANT_CONSULTATION = 7616469008497;
  var VARIANT_AFTERCARE    = 7616469139569;

  // ── CASTING ────────────────────────────────────────────────────────────
  // Model casting, July 2026. Free (no cart, no checkout), reachable only
  // via openScheduler('casting') from /pages/casting.
  // TO REVERT AFTER THE SHOOT: unpublish /pages/casting and set
  // FREE_TYPES = [] in the Apps Script. Nothing else needs to change.
  var CASTING = {
    month: 7,                       // August, zero-indexed
    year:  2026,
    // Wed/Thu/Fri, then the following Monday.
    dates: ['2026-08-05', '2026-08-06', '2026-08-07', '2026-08-10', '2026-08-11', '2026-08-12'],
    // Must match CASTING.slots in the Apps Script.
    slots: ['9:30 AM', '11:30 AM', '2:00 PM', '4:30 PM'],
    location: 'The Renatural Studio, DUMBO, Brooklyn',
    durationLabel: '90 minutes'
  };

  // Appointment types that skip checkout entirely. Enforced again server-side.
  var FREE_TYPES = ['casting'];


  // ── Colors ──────────────────────────────────────────────────────────────────
  var INK         = '#141923';
  var CREAM       = '#F7F5ED';
  var WARM        = '#8B6F47';
  var SAND        = '#D8D0C4';
  var MUTED       = '#6B5F52';
  var LIGHT       = '#EEEAE3';
  var POWDER      = '#A1C0F1';
  var POWDER_DEEP = '#6B94D6';
  var STONE       = '#E5E2DB';

  var css = [
    '@import url(\'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=DM+Sans:wght@300;400;500&display=swap\');',

    '.rnss-overlay{position:fixed;inset:0;background:rgba(20,25,35,0.8);z-index:9999;display:flex;align-items:center;justify-content:center;padding:24px;opacity:0;transition:opacity 0.25s ease;}',
    '.rnss-overlay.rnss-visible{opacity:1;}',
    '.rnss-modal{background:' + CREAM + ';width:100%;max-width:660px;position:relative;overflow:hidden;max-height:90vh;display:flex;flex-direction:column;transform:translateY(10px);transition:transform 0.25s ease;}',
    '.rnss-overlay.rnss-visible .rnss-modal{transform:translateY(0);}',

    '.rnss-progress{display:flex;gap:3px;flex-shrink:0;}',
    '.rnss-seg{height:2px;flex:1;background:' + STONE + ';transition:background 0.4s ease;}',
    '.rnss-seg.rnss-done{background:' + INK + ';}',
    '.rnss-seg.rnss-active{background:' + WARM + ';}',

    '.rnss-header{padding:32px 48px 0;flex-shrink:0;}',
    '.rnss-eyebrow{font-family:\'DM Sans\',sans-serif;font-size:10px;letter-spacing:0.22em;text-transform:uppercase;color:' + MUTED + ';margin:0 0 10px;}',
    '.rnss-title{font-family:\'Cormorant Garamond\',serif;font-size:36px;font-weight:300;font-style:italic;color:' + INK + ';line-height:1.1;margin:0 0 10px;}',
    '.rnss-sub{font-family:\'DM Sans\',sans-serif;font-size:12px;color:' + MUTED + ';line-height:1.7;max-width:420px;margin:0;}',

    '.rnss-body{padding:24px 48px 0;overflow-y:auto;flex:1;-webkit-overflow-scrolling:touch;}',
    '.rnss-body::-webkit-scrollbar{width:3px;}',
    '.rnss-body::-webkit-scrollbar-thumb{background:' + STONE + ';}',

    '.rnss-screen{animation:rnssUp 0.28s ease forwards;}',
    '@keyframes rnssUp{from{opacity:0;transform:translateY(8px);}to{opacity:1;transform:translateY(0);}}',

    '.rnss-type-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;}',
    '.rnss-type-card{border:1px solid ' + STONE + ';cursor:pointer;transition:border-color 0.2s;overflow:hidden;position:relative;}',
    '.rnss-type-card:hover{border-color:' + WARM + ';}',
    '.rnss-type-card.rnss-selected{border:1.5px solid ' + INK + ';}',
    '.rnss-type-img{width:100%;height:140px;display:flex;align-items:flex-end;padding:14px;position:relative;overflow:hidden;}',
    '.rnss-type-img-light::before{content:\'\';position:absolute;inset:0;background:linear-gradient(160deg,#C4A882 0%,#8B6F47 100%);}',
    '.rnss-type-img-dark::before{content:\'\';position:absolute;inset:0;background:linear-gradient(160deg,#3D2E1E 0%,#141923 100%);}',
    '.rnss-type-img img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}',
    '.rnss-type-img-label{position:relative;font-family:\'Cormorant Garamond\',serif;font-size:13px;font-style:italic;color:rgba(247,245,237,0.7);}',
    '.rnss-type-body{padding:16px 18px 18px;}',
    '.rnss-type-title{font-family:\'Cormorant Garamond\',serif;font-size:20px;color:' + INK + ';margin:0 0 5px;line-height:1.1;}',
    '.rnss-type-desc{font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';line-height:1.65;margin:0;}',
    '.rnss-type-price{font-family:\'DM Sans\',sans-serif;font-size:12px;font-weight:500;color:' + INK + ';margin-top:8px;}',
    '.rnss-type-check{position:absolute;top:12px;right:12px;width:22px;height:22px;background:' + INK + ';border-radius:50%;display:flex;align-items:center;justify-content:center;color:' + CREAM + ';font-size:11px;}',

    '.rnss-section-label{font-family:\'DM Sans\',sans-serif;font-size:9px;letter-spacing:0.2em;text-transform:uppercase;color:' + MUTED + ';margin:22px 0 10px;display:block;}',
    '.rnss-section-label:first-child{margin-top:0;}',

    // Status cards — new/returning (required)
    '.rnss-status-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:4px;}',
    '.rnss-status-card{border:1px solid ' + STONE + ';cursor:pointer;transition:border-color .2s,background .2s;padding:20px 22px;position:relative;overflow:hidden;}',
    '.rnss-status-card:hover{border-color:' + WARM + ';}',
    '.rnss-status-card.rnss-selected{border-color:' + INK + ';background:rgba(20,25,35,.03);}',
    '.rnss-status-card::before{content:\'\';position:absolute;top:0;left:0;width:2px;height:100%;background:' + STONE + ';transition:background .2s;}',
    '.rnss-status-card.rnss-selected::before{background:' + INK + ';}',
    '.rnss-status-card-label{font-family:\'Cormorant Garamond\',serif;font-size:22px;font-weight:300;color:' + INK + ';display:block;margin-bottom:5px;line-height:1.1;}',
    '.rnss-status-card-sub{font-family:\'DM Sans\',sans-serif;font-size:10px;color:' + MUTED + ';line-height:1.6;display:block;}',
    '.rnss-status-card-check{position:absolute;top:14px;right:14px;width:18px;height:18px;background:' + INK + ';border-radius:50%;display:none;align-items:center;justify-content:center;color:' + CREAM + ';font-size:9px;}',
    '.rnss-status-card.rnss-selected .rnss-status-card-check{display:flex;}',
    // Required indicator
    '.rnss-required-note{font-family:\'DM Sans\',sans-serif;font-size:10px;color:' + WARM + ';font-style:italic;margin-bottom:16px;display:block;}',

    // Pills — multi-select
    '.rnss-pill-group{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:4px;}',
    '.rnss-pill{padding:7px 16px;border:1px solid ' + STONE + ';background:transparent;cursor:pointer;font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';transition:all 0.15s;user-select:none;}',
    '.rnss-pill:hover{border-color:' + WARM + ';color:' + INK + ';}',
    '.rnss-pill.rnss-selected{background:' + INK + ';border-color:' + INK + ';color:' + CREAM + ';}',

    '.rnss-field{margin-bottom:18px;}',
    '.rnss-field-row{display:grid;grid-template-columns:1fr 1fr;gap:24px;}',
    '.rnss-field-label{font-family:\'DM Sans\',sans-serif;font-size:9px;letter-spacing:0.2em;text-transform:uppercase;color:' + MUTED + ';display:block;margin-bottom:7px;}',
    '.rnss-field-optional{font-size:9px;opacity:0.6;text-transform:none;letter-spacing:0;font-family:\'DM Sans\',sans-serif;}',
    '.rnss-input{width:100%;padding:11px 0;border:none;border-bottom:1px solid ' + STONE + ';background:transparent;font-family:\'DM Sans\',sans-serif;font-size:13px;color:' + INK + ';outline:none;transition:border-color 0.2s;box-sizing:border-box;}',
    '.rnss-input:focus{border-bottom-color:' + INK + ';}',
    '.rnss-input::placeholder{color:' + STONE + ';}',
    '.rnss-textarea{width:100%;padding:11px 0;border:none;border-bottom:1px solid ' + STONE + ';background:transparent;font-family:\'DM Sans\',sans-serif;font-size:13px;color:' + INK + ';outline:none;transition:border-color 0.2s;box-sizing:border-box;resize:none;height:64px;}',
    '.rnss-textarea:focus{border-bottom-color:' + INK + ';}',
    '.rnss-textarea::placeholder{color:' + STONE + ';}',

    '.rnss-mode-toggle{display:flex;margin-bottom:20px;}',
    '.rnss-mode-btn{flex:1;padding:10px;border:1px solid ' + STONE + ';background:transparent;cursor:pointer;font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';text-align:center;transition:all 0.15s;}',
    '.rnss-mode-btn:first-child{border-right:none;}',
    '.rnss-mode-btn:hover{color:' + INK + ';}',
    '.rnss-mode-btn.rnss-selected{background:' + INK + ';border-color:' + INK + ';color:' + CREAM + ';}',

    '.rnss-location-note{display:flex;align-items:flex-start;gap:10px;padding:14px 16px;border-left:2px solid ' + POWDER + ';background:rgba(161,192,241,.06);margin-bottom:20px;}',
    '.rnss-location-note-text{font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';line-height:1.7;}',
    '.rnss-location-note-text strong{color:' + INK + ';font-weight:500;}',

    '.rnss-summary-card{background:' + LIGHT + ';border:1px solid ' + STONE + ';padding:20px 24px;margin-bottom:20px;}',
    '.rnss-summary-row{display:flex;justify-content:space-between;align-items:baseline;padding:8px 0;border-bottom:1px solid ' + STONE + ';}',
    '.rnss-summary-row:last-child{border-bottom:none;}',
    '.rnss-summary-key{font-family:\'DM Sans\',sans-serif;font-size:9px;letter-spacing:0.18em;text-transform:uppercase;color:' + MUTED + ';}',
    '.rnss-summary-val{font-family:\'Cormorant Garamond\',serif;font-size:15px;color:' + INK + ';}',
    '.rnss-summary-note{font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';line-height:1.7;margin:0 0 20px;font-style:italic;}',

    '.rnss-pay-block{background:' + LIGHT + ';border:1px solid ' + STONE + ';padding:20px 24px;margin-bottom:16px;}',
    '.rnss-pay-row{display:flex;align-items:baseline;justify-content:space-between;padding:8px 0;border-bottom:1px solid ' + STONE + ';}',
    '.rnss-pay-row:last-child{border-bottom:none;}',
    '.rnss-pay-key{font-family:\'DM Sans\',sans-serif;font-size:9px;letter-spacing:0.18em;text-transform:uppercase;color:' + MUTED + ';}',
    '.rnss-pay-val{font-family:\'Cormorant Garamond\',serif;font-size:15px;color:' + INK + ';}',
    '.rnss-pay-total{font-family:\'DM Sans\',sans-serif;font-size:18px;font-weight:700;color:' + INK + ';}',
    '.rnss-pay-note{font-family:\'DM Sans\',sans-serif;font-size:10px;color:' + MUTED + ';font-style:italic;margin-bottom:16px;}',

    // Calendar
    '.rnss-cal{margin-bottom:20px;}',
    '.rnss-cal-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;}',
    '.rnss-cal-month{font-family:\'Cormorant Garamond\',serif;font-size:20px;font-style:italic;color:' + INK + ';}',
    '.rnss-cal-nav{background:none;border:1px solid ' + STONE + ';color:' + MUTED + ';width:28px;height:28px;cursor:pointer;font-size:13px;display:flex;align-items:center;justify-content:center;transition:border-color .15s;}',
    '.rnss-cal-nav:hover{border-color:' + WARM + ';color:' + INK + ';}',
    '.rnss-cal-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:3px;margin-bottom:16px;}',
    '.rnss-cal-dow{font-family:\'DM Sans\',sans-serif;font-size:8px;letter-spacing:.12em;text-transform:uppercase;color:' + MUTED + ';text-align:center;padding:6px 0;}',
    '.rnss-cal-day{aspect-ratio:1;display:flex;align-items:center;justify-content:center;font-family:\'DM Sans\',sans-serif;font-size:12px;color:' + INK + ';cursor:pointer;border:1px solid transparent;transition:all .15s;}',
    '.rnss-cal-day:hover:not(.rnss-cal-day-empty):not(.rnss-cal-day-unavail){border-color:' + WARM + ';color:' + WARM + ';}',
    '.rnss-cal-day.rnss-cal-day-selected{background:' + INK + ';color:' + CREAM + ';}',
    '.rnss-cal-day-empty{cursor:default;}',
    '.rnss-cal-day-unavail{color:' + STONE + ';cursor:default;}',
    '.rnss-cal-day-today{font-weight:700;color:' + WARM + ';}',
    '.rnss-cal-day-loading{color:' + SAND + ';cursor:default;}',

    // Time slots
    '.rnss-slots{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:16px;}',
    '.rnss-slot{padding:9px 6px;border:1px solid ' + STONE + ';background:transparent;font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';cursor:pointer;text-align:center;transition:all .15s;}',
    '.rnss-slot:hover{border-color:' + WARM + ';color:' + INK + ';}',
    '.rnss-slot.rnss-selected{background:' + INK + ';border-color:' + INK + ';color:' + CREAM + ';}',
    '.rnss-slot-label{font-family:\'DM Sans\',sans-serif;font-size:9px;letter-spacing:.15em;text-transform:uppercase;color:' + MUTED + ';margin-bottom:10px;display:block;}',
    '.rnss-slots-loading{font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';font-style:italic;padding:12px 0;}',
    '.rnss-slots-empty{font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';font-style:italic;padding:12px 0;}',

    // Scroll hint — used on step 4 between calendar and times
    '.rnss-scroll-hint{display:flex;align-items:center;justify-content:center;gap:8px;padding:10px 0 6px;font-family:\'DM Sans\',sans-serif;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:' + POWDER_DEEP + ';animation:rnssHintBounce 1.6s ease-in-out infinite;}',
    '@keyframes rnssHintBounce{0%,100%{transform:translateY(0);}50%{transform:translateY(3px);}}',
    '.rnss-scroll-hint-dot{width:10px;height:5px;background:' + POWDER_DEEP + ';border-radius:0 0 10px 10px;flex-shrink:0;}',

    '.rnss-btn-primary{padding:13px 32px;background:' + INK + ';color:' + CREAM + ';border:none;cursor:pointer;font-family:\'DM Sans\',sans-serif;font-size:10px;letter-spacing:0.18em;text-transform:uppercase;transition:background 0.2s;}',
    '.rnss-btn-primary:hover{background:#251B17;}',
    '.rnss-btn-primary:disabled{background:' + STONE + ';color:' + MUTED + ';cursor:not-allowed;}',
    '.rnss-btn-back{background:none;border:none;cursor:pointer;font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';padding:0;margin:0 0 20px;display:flex;align-items:center;gap:6px;transition:color 0.15s;}',
    '.rnss-btn-back:hover{color:' + INK + ';}',

    '.rnss-footer{display:flex;align-items:center;justify-content:space-between;padding:16px 48px 28px;flex-shrink:0;}',
    '.rnss-step-count{font-family:\'DM Sans\',sans-serif;font-size:10px;color:' + MUTED + ';}',

    '.rnss-close{position:absolute;top:20px;right:24px;background:none;border:none;cursor:pointer;font-size:18px;color:' + MUTED + ';line-height:1;transition:color 0.15s;z-index:10;}',
    '.rnss-close:hover{color:' + INK + ';}',

    '@media(max-width:600px){',
    '.rnss-header{padding:24px 24px 0;}',
    '.rnss-body{padding:20px 24px 0;}',
    '.rnss-footer{padding:14px 24px 22px;}',
    '.rnss-title{font-size:28px;}',
    '.rnss-type-grid,.rnss-status-grid{grid-template-columns:1fr;}',
    '.rnss-field-row{grid-template-columns:1fr;gap:0;}',
    '.rnss-slots{grid-template-columns:repeat(2,1fr);}',
    '}',

    // ── Casting picker: two columns on desktop, stacked on mobile ────────
    '.rnc-pick{display:flex;gap:16px;align-items:flex-start;}',
    '.rnc-col{display:flex;flex-direction:column;gap:8px;}',
    '.rnc-col-dates{flex:0 0 46%;}',
    '.rnc-col-times{flex:1;min-width:0;}',
    '.rnc-lbl{font-family:\'DM Sans\',sans-serif;font-size:9px;letter-spacing:.15em;text-transform:uppercase;color:' + MUTED + ';margin:0 0 2px;display:block;}',
    '.rnc-date{padding:12px 14px;border:1px solid ' + STONE + ';background:transparent;cursor:pointer;text-align:left;transition:all .15s;font-family:\'DM Sans\',sans-serif;line-height:1.25;}',
    '.rnc-date:hover{border-color:' + WARM + ';}',
    '.rnc-date .rnc-dow{display:block;font-size:9px;letter-spacing:.16em;text-transform:uppercase;color:' + MUTED + ';}',
    '.rnc-date .rnc-dnum{display:block;font-size:14px;color:' + INK + ';margin-top:2px;}',
    '.rnc-date.rnc-on{background:' + INK + ';border-color:' + INK + ';}',
    '.rnc-date.rnc-on .rnc-dow{color:rgba(255,255,255,.62);}',
    '.rnc-date.rnc-on .rnc-dnum{color:' + CREAM + ';}',
    '.rnc-time{padding:12px 8px;border:1px solid ' + STONE + ';background:transparent;font-family:\'DM Sans\',sans-serif;font-size:12px;color:' + MUTED + ';cursor:pointer;text-align:center;transition:all .15s;}',
    '.rnc-time:hover{border-color:' + WARM + ';color:' + INK + ';}',
    '.rnc-time.rnc-on{background:' + INK + ';border-color:' + INK + ';color:' + CREAM + ';}',
    '.rnc-time[disabled]{opacity:.32;cursor:not-allowed;text-decoration:line-through;}',
    '.rnc-time[disabled]:hover{border-color:' + STONE + ';color:' + MUTED + ';}',
    '.rnc-hint{font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';font-style:italic;padding:14px 2px;line-height:1.5;}',
    '@media(max-width:620px){',
    '  .rnc-pick{flex-direction:column;gap:18px;}',
    '  .rnc-col-dates{flex:none;width:100%;display:grid;grid-template-columns:1fr 1fr;gap:8px;}',
    '  .rnc-col-times{width:100%;display:grid;grid-template-columns:1fr 1fr;gap:8px;}',
    '  .rnc-lbl{grid-column:1/-1;}',
    '  .rnc-date{padding:10px 12px;}',
    '}',
    // ── Casting intake ─────────────────────────────────────
    '.rni-block{margin-bottom:18px;}',
    '.rni-pills{display:flex;flex-wrap:wrap;gap:6px;}',
    '.rni-pill{padding:9px 13px;border:1px solid ' + STONE + ';background:transparent;font-family:\'DM Sans\',sans-serif;font-size:11px;color:' + MUTED + ';cursor:pointer;transition:all .15s;line-height:1.2;}',
    '.rni-pill:hover{border-color:' + WARM + ';color:' + INK + ';}',
    '.rni-pill.rnc-on{background:' + INK + ';border-color:' + INK + ';color:' + CREAM + ';}',
    '.rni-rule{height:1px;background:' + STONE + ';margin:24px 0 18px;}',
    '.rni-specs{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;}',
    '@media(max-width:620px){.rni-specs{grid-template-columns:1fr 1fr;}}',

    '@media(max-width:620px){.rnss-header{padding:24px 24px 0;}.rnss-body{padding:0 24px;}.rnss-footer{padding:14px 24px 22px;}}',

  ].join('\n');

  var h         = React.createElement;
  var useState  = React.useState;
  var useEffect = React.useEffect;
  var useRef    = React.useRef;

  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DAYS   = ['Su','Mo','Tu','We','Th','Fr','Sa'];

  // Updated headers — step 4 is now calendar/time, step 5 is review/pay
  var HEADERS = {
    1:    { eyebrow: 'Book an Appointment', title: 'What brings you in?',      sub: 'Virtual and in-person appointments available. $50 per session.' },
    '2a': { eyebrow: 'Consultation',        title: 'A little about you.',      sub: 'Helps your stylist prepare.' },
    '2b': { eyebrow: 'Aftercare',           title: 'About your wig.',          sub: 'Help us understand what you\'re working with.' },
    3:    { eyebrow: 'Contact',             title: 'How should we reach you?', sub: '' },
    4:    { eyebrow: 'Availability',        title: 'Pick your time.',          sub: 'Select a date, then choose an available slot.' },
    5:    { eyebrow: 'Review + Pay',        title: 'Confirm your booking.',    sub: 'Payment is required to hold your appointment.' },
    // Casting screens
    '2c': { eyebrow: 'Model Casting',      title: 'What to expect.',          sub: 'Please read through before choosing your slot.' },
    '2d': { eyebrow: 'Model Casting',      title: 'A few details.',           sub: 'Helps your stylist prepare before you arrive.' },
  };

  // Casting overrides — same screens, different words. Falls back to HEADERS.
  var CASTING_HEADERS = {
    4: { eyebrow: 'Availability', title: 'Choose your session.', sub: 'Pick a day, then a time.' },
    5: { eyebrow: 'Review',       title: 'Confirm your booking.', sub: 'No payment required.' },
    6:    { eyebrow: 'Confirmed',          title: 'You\'re booked.',           sub: '' },
  };

  // Casting intake — screen 2D. Tap-to-answer, minimal typing.
  var INTAKE = {
    scalp: ['Healthy, no concerns', 'Dryness or flaking',
            'Sensitivity or irritation', 'Ongoing condition'],
    hair:  ['Natural / unprocessed', 'Relaxed', 'Transitioning',
            'Locs', 'Braids or protective style', 'Shaved or bald'],
    length:['Above the ear', 'Ear to shoulder',
            'Shoulder to mid-back', 'Past mid-back'],
    wig:   ['Never worn one', 'Occasionally', 'Regularly']
  };

  // ── Casting briefing copy \u2014 PLACEHOLDER. Replace before sending links. ──
  var CASTING_BRIEF = [
    { h: 'How long it takes', p: [
      'Plan for about 90 minutes on site. Please arrive 10 minutes early so we can start on time. Sessions run back to back.'
    ]},
    { h: 'How to show up', p: [
      'Please arrive with a clean, product-free scalp, free of oils, gels, or styling residue.',
      'We will need your hair to be as flat as possible for our casting session. We will be applying our glueless wigs onto your head. Depending on length, we recommend a low ponytail, a front-to-back braid, or cornrows worn straight back.',
      'Please, no weave or extensions that make it hard for us to apply a wig cap and lay your hair flat for wig application.',
      'We also ask that you keep makeup minimal and skip lashes, and wear a white tank top or bandeau to your appointment.'
    ]},
    { h: 'What to bring', p: [
      'Just yourself and a valid photo ID.'
    ]},
    { h: 'What happens in the room', p: [
      'Your session takes place in our in-studio salon at our DUMBO office. Our licensed cosmetologist, founder, and marketing and production team will be present.',
      'All scalp and hair handling is done by our licensed cosmetologist, who will assess your scalp, take head measurements, fit you in one or more wig units, and discuss shade and texture.',
      'Our wigs are glueless. We will not be applying glue to your skin to adhere the wigs.',
      'Photos and video will be taken for casting review.'
    ]},
    { h: 'Paperwork', p: [
      'After you book, you\u2019ll receive a folder with documents to sign electronically. It must be completed before your session begins.'
    ]}
  ];

  // What's on your mind options — correct order + title case
  var MIND_OPTIONS = [
    'General Questions',
    'Fit & Measurements',
    'Deciding on Texture or Length',
    'Comparing Options'
  ];

  function getCardImage(type) {
    var el = document.getElementById('rnba-settings');
    if (!el) return null;
    if (type === 'consultation') return el.getAttribute('data-consultation-image') || null;
    if (type === 'aftercare')    return el.getAttribute('data-aftercare-image')    || null;
    return null;
  }

  function formatDateStr(year, month, day) {
    var m = String(month + 1).padStart(2, '0');
    var d = String(day).padStart(2, '0');
    return year + '-' + m + '-' + d;
  }

  function Scheduler(_ref) {
    var initialType = _ref.initialType;
    var onClose     = _ref.onClose;

    var isCasting   = initialType === 'casting';

    var _screen     = useState(isCasting ? 3 : 1);
    var screen      = _screen[0], setScreen = _screen[1];

    var _type       = useState(initialType || null);
    var apptType    = _type[0], setApptType = _type[1];

    var _mode       = useState(isCasting ? 'in-person' : 'virtual');
    var apptMode    = _mode[0], setApptMode = _mode[1];

    // FIX 1: custStatus required — canAdvance on 2a checks this
    var _status     = useState(null);
    var custStatus  = _status[0], setCustStatus = _status[1];

    // FIX 2: reasons is now an array for multi-select
    var _reasons    = useState([]);
    var reasons     = _reasons[0], setReasons = _reasons[1];

    var _acTexture  = useState(null);
    var acTexture   = _acTexture[0], setAcTexture = _acTexture[1];

    var _acTone     = useState(null);
    var acTone      = _acTone[0], setAcTone = _acTone[1];

    var _acNeed     = useState(null);
    var acNeed      = _acNeed[0], setAcNeed = _acNeed[1];

    var _acDuration = useState(null);
    var acDuration  = _acDuration[0], setAcDuration = _acDuration[1];

    var _name       = useState('');
    var name        = _name[0], setName = _name[1];

    var _email      = useState('');
    var email       = _email[0], setEmail = _email[1];

    var _phone      = useState('');
    var phone       = _phone[0], setPhone = _phone[1];

    var _notes      = useState('');
    var notes       = _notes[0], setNotes = _notes[1];

    var _visible    = useState(false);
    var visible     = _visible[0], setVisible = _visible[1];

    var _submitting = useState(false);
    var submitting  = _submitting[0], setSubmitting = _submitting[1];

    var now = new Date();
    var _scalp      = useState(null);
    var scalp       = _scalp[0], setScalp = _scalp[1];

    var _hairType   = useState(null);
    var hairType    = _hairType[0], setHairType = _hairType[1];

    var _hairLen    = useState(null);
    var hairLen     = _hairLen[0], setHairLen = _hairLen[1];

    var _wigExp     = useState(null);
    var wigExp      = _wigExp[0], setWigExp = _wigExp[1];

    var _sens       = useState('');
    var sens        = _sens[0], setSens = _sens[1];

    var _specs      = useState({ height: '', dress: '', bra: '', shoe: '' });
    var specs       = _specs[0], setSpecs = _specs[1];

    var _lastName   = useState('');
    var lastName    = _lastName[0], setLastName = _lastName[1];

    var _ack        = useState(false);
    var ackChecked  = _ack[0], setAckChecked = _ack[1];

    var _booked     = useState(null);
    var bookedInfo  = _booked[0], setBookedInfo = _booked[1];

    var _calYear  = useState(isCasting ? CASTING.year : now.getFullYear());
    var calYear   = _calYear[0], setCalYear = _calYear[1];

    var _calMonth = useState(isCasting ? CASTING.month : now.getMonth());
    var calMonth  = _calMonth[0], setCalMonth = _calMonth[1];

    var _selDay   = useState(null);
    var selDay    = _selDay[0], setSelDay = _selDay[1];

    var _selTime  = useState(null);
    var selTime   = _selTime[0], setSelTime = _selTime[1];

    var _slots        = useState({});
    var slots         = _slots[0], setSlots = _slots[1];

    var _slotsLoading = useState(false);
    var slotsLoading  = _slotsLoading[0], setSlotsLoading = _slotsLoading[1];

    var _slotsError   = useState(null);
    var slotsError    = _slotsError[0], setSlotsError = _slotsError[1];

    var bodyRef = useRef(null);

    useEffect(function() {
      var t = setTimeout(function() { setVisible(true); }, 20);
      return function() { clearTimeout(t); };
    }, []);

    useEffect(function() {
      if (bodyRef.current) bodyRef.current.scrollTop = 0;
    }, [screen]);

    // Fetch slots when a day is selected
    useEffect(function() {
      if (!selDay) return;
      var dateStr = formatDateStr(calYear, calMonth, selDay);
      if (slots[dateStr] !== undefined) return;

      setSlotsLoading(true);
      setSlotsError(null);

      fetch(APPS_SCRIPT_URL + '?action=getSlots&date=' + dateStr + '&type=' + (apptType || 'consultation'))
        .then(function(r) { return r.json(); })
        .then(function(data) {
          setSlotsLoading(false);
          if (data.error) {
            setSlotsError(data.error);
            setSlots(function(prev) { var next = Object.assign({}, prev); next[dateStr] = []; return next; });
          } else {
            setSlots(function(prev) { var next = Object.assign({}, prev); next[dateStr] = data.slots || []; return next; });
          }
        })
        .catch(function() {
          setSlotsLoading(false);
          setSlotsError('Could not load availability. Please try again.');
          setSlots(function(prev) { var next = Object.assign({}, prev); next[dateStr] = []; return next; });
        });
    }, [selDay, calYear, calMonth]);

    function handleClose() { setVisible(false); setTimeout(onClose, 250); }

    // Casting collects first and last separately; everything downstream
    // (calendar title, sheet, Klaviyo) wants one name.
    function fullName() {
      return isCasting ? (name.trim() + ' ' + lastName.trim()).trim() : name;
    }

    function advance() {
      if (screen === 1)                       { setScreen(apptType === 'consultation' ? '2a' : '2b'); return; }
      if (screen === '2a' || screen === '2b') { setScreen(3); return; }
      if (screen === '2c')                    { setScreen(4); return; }
      if (screen === '2d')                    { setScreen(5); return; }
      if (screen === 3)                       { setScreen(isCasting ? '2c' : 4); return; }
      if (screen === 4)                       { setScreen(isCasting ? '2d' : 5); return; }
    }

    function back() {
      if (screen === '2a' || screen === '2b') { setScreen(1); return; }
      if (screen === '2c')                    { setScreen(3); return; }
      if (screen === '2d')                    { setScreen(4); return; }
      if (screen === 3)                       { if (isCasting) return;
                                                setScreen(apptType === 'consultation' ? '2a' : '2b'); return; }
      if (screen === 4)                       { setScreen(isCasting ? '2c' : 3); return; }
      if (screen === 5)                       { setScreen(isCasting ? '2d' : 4); return; }
    }

    function canAdvance() {
      if (screen === 1)    return !!apptType;
      // FIX 1: new/returning is now required
      if (screen === '2a') return !!custStatus;
      if (screen === '2b') return true;
      if (screen === '2c') return ackChecked;
      if (screen === '2d') {
        return !!scalp && !!hairType && !!hairLen && !!wigExp &&
               specs.height.trim() && specs.dress.trim() &&
               specs.bra.trim()    && specs.shoe.trim();
      }
      if (screen === 3) {
        var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
        if (!isCasting) return name.trim().length > 0 && emailOk;
        // Casting: all four required. Phone matters on shoot day.
        return name.trim().length > 0 && lastName.trim().length > 0 &&
               emailOk && phone.replace(/\D/g, '').length >= 10;
      }
      // FIX: step 4 now owns both date and time — both required
      if (screen === 4)    return !!selDay && !!selTime;
      return false;
    }

    // Toggle a reason in/out of the reasons array
    function toggleReason(r) {
      setReasons(function(prev) {
        return prev.includes(r)
          ? prev.filter(function(x) { return x !== r; })
          : prev.concat([r]);
      });
    }

    // ── Direct book — free types only. No cart, no checkout. ──────
    function handleDirectBook() {
      if (submitting) return;
      setSubmitting(true);

      var dateStr = formatDateStr(calYear, calMonth, selDay);
      var payload = {
        action: 'book', appt_type: apptType, appt_mode: apptMode,
        appt_date: dateStr, appt_time: selTime,
        name: fullName(), email: email, phone: phone || '', notes: notes || '',
        acknowledged: ackChecked,
        // Sent so the calendar invite can carry the briefing without the
        // copy existing in a second file. CASTING_BRIEF stays the only
        // place this text is edited.
        brief: CASTING_BRIEF.map(function(b) {
          return b.h.toUpperCase() + '\n' + b.p.join('\n\n');
        }).join('\n\n'),
        scalp: scalp, hair_type: hairType, hair_length: hairLen,
        wig_experience: wigExp, sensitivities: sens || '',
        height: specs.height, dress_size: specs.dress,
        bra_size: specs.bra, shoe_size: specs.shoe
      };

      // text/plain avoids the CORS preflight Apps Script cannot answer.
      fetch(APPS_SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data && data.ok) { setBookedInfo(data); setScreen(6); setSubmitting(false); }
          else { setSubmitting(false); alert((data && data.error) || 'Could not book. Please try again.'); }
        })
        .catch(function() {
          setSubmitting(false);
          alert('Could not book. Please check your connection and try again.');
        });
    }

    // \u2500\u2500 Pay & Book \u2500────────────────────────────────────────────────────────
    function handleCheckout() {
      if (submitting) return;
      setSubmitting(true);

      var variantId = apptType === 'consultation' ? VARIANT_CONSULTATION : VARIANT_AFTERCARE;
      var dateStr   = formatDateStr(calYear, calMonth, selDay);

      var attributes = [
        { key: 'appt_mode',     value: apptMode },
        { key: 'appt_date',     value: dateStr },
        { key: 'appt_time',     value: selTime },
        { key: 'appt_notes',    value: notes || '' },
        { key: 'appt_reason',   value: reasons.join(', ') },
        { key: 'appt_status',   value: custStatus || '' },
        { key: 'appt_texture',  value: acTexture || '' },
        { key: 'appt_tone',     value: acTone || '' },
        { key: 'appt_need',     value: acNeed || '' },
        { key: 'appt_duration', value: acDuration || '' },
        { key: 'customer_name', value: name },
        { key: 'customer_email', value: email },
        { key: 'customer_phone', value: phone || '' },
      ];

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              attributes: attributes.reduce(function(acc, a) { acc[a.key] = a.value; return acc; }, {})
            })
          });
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              note: 'Appointment: ' + (apptType === 'consultation' ? 'Consultation' : 'Aftercare') + ' on ' + dateStr + ' at ' + selTime,
              attributes: attributes.reduce(function(acc, a) { acc[a.key] = a.value; return acc; }, {})
            })
          });
        })
        .then(function() { window.location.href = '/checkout'; })
        .catch(function() { setSubmitting(false); alert('Something went wrong. Please try again.'); });
    }

    var totalSteps = isCasting ? 6 : 5;
    var stepNum = ({ 3:1, '2c':2, 4:3, '2d':4, 5:5, 6:6 })[screen] || 1;
    // Casting has 5 steps too (brief, contact, time, confirm, done) so the
    // progress bar stays honest without a second component.
    if (!isCasting) stepNum = ({ 1:1, '2a':2, '2b':2, 3:3, 4:4, 5:5 })[screen] || 1;

    function renderProgress() {
      return h('div', { className: 'rnss-progress' },
        Array.apply(null, { length: totalSteps }).map(function(_, i) { return i + 1; }).map(function(n) {
          var cls = 'rnss-seg' + (n < stepNum ? ' rnss-done' : n === stepNum ? ' rnss-active' : '');
          return h('div', { key: n, className: cls });
        })
      );
    }

    function renderHeader() {
      var hdr = (isCasting && CASTING_HEADERS[screen]) || HEADERS[screen] || HEADERS[1];
      return h('div', { className: 'rnss-header' },
        h('p', { className: 'rnss-eyebrow' }, hdr.eyebrow),
        h('h2', { className: 'rnss-title' }, hdr.title),
        hdr.sub && h('p', { className: 'rnss-sub' }, hdr.sub)
      );
    }

    // ── Screen 1: Appointment type ─────────────────────────────────────────
    function renderScreen1() {
      var cards = [
        { id: 'consultation', title: 'Consultation',   desc: 'Pre-purchase. Texture guidance, fit walkthrough, or questions about what\'s right for you.', imgClass: 'rnss-type-img-light', imgLabel: 'Pre-purchase' },
        { id: 'aftercare',    title: 'Aftercare',      desc: 'Post-purchase. Install help, styling, or care questions about your wig.',                     imgClass: 'rnss-type-img-dark',  imgLabel: 'Post-purchase' }
      ];
      return h('div', { className: 'rnss-screen' },
        h('div', { className: 'rnss-type-grid' },
          cards.map(function(card) {
            var isSel   = apptType === card.id;
            var cardImg = getCardImage(card.id);
            return h('div', { key: card.id, className: 'rnss-type-card' + (isSel ? ' rnss-selected' : ''), onClick: function() { setApptType(card.id); } },
              h('div', { className: 'rnss-type-img ' + (cardImg ? '' : card.imgClass) },
                cardImg ? h('img', { src: cardImg, alt: card.title }) : null,
                h('span', { className: 'rnss-type-img-label' }, card.imgLabel)
              ),
              h('div', { className: 'rnss-type-body' },
                h('p', { className: 'rnss-type-title' }, card.title),
                h('p', { className: 'rnss-type-desc' }, card.desc),
                h('p', { className: 'rnss-type-price' }, '$50 \u00b7 30 min')
              ),
              isSel && h('div', { className: 'rnss-type-check' }, '\u2713')
            );
          })
        )
      );
    }

    // \u2500\u2500 Screen 2C: Casting briefing + acknowledgement \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    function renderScreen2C() {
      return h('div', { className: 'rnss-screen' },
        h('div', { style: { border: '1px solid rgba(0,0,0,0.10)', padding: '18px 20px', marginBottom: '18px' } },
          CASTING_BRIEF.map(function(b, i) {
            return h('div', { key: b.h, style: { marginBottom: i === CASTING_BRIEF.length - 1 ? 0 : '20px' } },
              h('p', { style: { margin: '0 0 6px', fontSize: '10px', fontWeight: 700,
                               letterSpacing: '.14em', textTransform: 'uppercase',
                               color: POWDER_DEEP } }, b.h),
              b.p.map(function(txt, n) {
                return h('p', {
                  key: n,
                  style: { margin: n === 0 ? 0 : '9px 0 0', fontSize: '13px', lineHeight: 1.55 }
                }, txt);
              })
            );
          })
        ),
        h('div', {
          onClick: function() { setAckChecked(!ackChecked); },
          style: { display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer',
                   border: '1px solid ' + (ackChecked ? 'rgba(0,0,0,0.45)' : 'rgba(0,0,0,0.14)'),
                   padding: '14px 16px', userSelect: 'none' }
        },
          h('span', {
            style: { flex: '0 0 auto', width: '18px', height: '18px', marginTop: '1px',
                     border: '1px solid rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center',
                     justifyContent: 'center', fontSize: '12px', lineHeight: 1 }
          }, ackChecked ? '\u2713' : ''),
          h('span', { style: { fontSize: '13px', lineHeight: 1.5 } },
            'I\u2019ve read the details above and understand how to prepare for my casting session.')
        )
      );
    }

    // ── Screen 2D: Casting intake — scalp, hair, specs ──────────────
    function renderScreen2D() {
      function pills(label, opts, val, setter) {
        return h('div', { className: 'rni-block', key: label },
          h('span', { className: 'rnc-lbl' }, label),
          h('div', { className: 'rni-pills' },
            opts.map(function(o) {
              return h('button', {
                key: o,
                className: 'rni-pill' + (val === o ? ' rnc-on' : ''),
                onClick: function() { setter(o); }
              }, o);
            })
          )
        );
      }

      function spec(label, key, ph) {
        return h('div', { className: 'rnss-field', key: key },
          h('label', { className: 'rnss-field-label' }, label),
          h('input', {
            className: 'rnss-input', type: 'text', placeholder: ph,
            value: specs[key],
            onChange: function(e) {
              var v = e.target.value;
              setSpecs(function(prev) {
                var next = { height: prev.height, dress: prev.dress,
                             bra: prev.bra, shoe: prev.shoe };
                next[key] = v;
                return next;
              });
            }
          })
        );
      }

      return h('div', { className: 'rnss-screen' },
        h('button', { className: 'rnss-btn-back', onClick: back }, '\u2190 Back'),

        pills('Scalp condition',       INTAKE.scalp,  scalp,    setScalp),
        pills('Current hair',          INTAKE.hair,   hairType, setHairType),
        pills('Natural hair length when straightened', INTAKE.length, hairLen, setHairLen),
        pills('Wig experience',        INTAKE.wig,    wigExp,   setWigExp),

        h('div', { className: 'rnss-field' },
          h('label', { className: 'rnss-field-label' }, 'Sensitivities or allergies ',
            h('span', { className: 'rnss-field-optional' }, '(optional)')),
          h('input', {
            className: 'rnss-input', type: 'text',
            placeholder: 'Adhesives, products, anything we should know\u2026',
            value: sens, onChange: function(e) { setSens(e.target.value); }
          })
        ),

        h('div', { className: 'rni-rule' }),
        h('span', { className: 'rnc-lbl' }, 'Model specs'),
        h('div', { className: 'rni-specs' },
          spec('Height',     'height', "5'8\""),
          spec('Dress Size', 'dress',  '6'),
          spec('Bra Size',   'bra',    '34B'),
          spec('Shoe Size',  'shoe',   '8.5')
        )
      );
    }

    // \u2500\u2500 Screen 6: Casting confirmation \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    function renderScreen6() {
      var when = (bookedInfo && bookedInfo.starts_at) ||
                 (MONTHS[calMonth] + ' ' + selDay + ' at ' + selTime);
      return h('div', { className: 'rnss-screen' },
        h('div', { className: 'rnss-pay-block' },
          [
            ['Date & Time', when],
            ['Duration',    CASTING.durationLabel],
            ['Location',    CASTING.location],
            ['Name',        fullName()],
            ['Email',       email]
          ].map(function(row) {
            return h('div', { key: row[0], className: 'rnss-pay-row' },
              h('span', { className: 'rnss-pay-key' }, row[0]),
              h('span', { className: 'rnss-pay-val' }, row[1])
            );
          })
        ),
        h('p', { className: 'rnss-pay-note' },
          'A calendar invite and confirmation email are on their way to ' + email + '. ' +
          'Your paperwork will arrive separately by email. Please complete and sign it before your session. ' +
          'If you need to reschedule, reply to your confirmation email.'),
        h('button', {
          className: 'rnss-btn-primary',
          onClick: handleClose,
          style: { width: '100%' }
        }, 'Done')
      );
    }

    // \u2500\u2500 Screen 2A: Consultation details \u2500───────────────────────────────────
    // FIX 1: new/returning required — note shown, Continue disabled until selected
    // FIX 2: what's on your mind — correct order, title case, multi-select
    function renderScreen2A() {
      return h('div', { className: 'rnss-screen' },
        h('button', { className: 'rnss-btn-back', onClick: back }, '\u2190 Back'),

        // New / returning — required
        h('span', { className: 'rnss-section-label', style: { marginTop: 0 } }, 'Are you a new or returning customer?'),
        h('span', { className: 'rnss-required-note' }, 'Required to continue'),
        h('div', { className: 'rnss-status-grid' },
          [
            { id: 'new',       label: 'New',       sub: "Haven\u2019t purchased yet.\nHere to explore and get guidance." },
            { id: 'returning', label: 'Returning', sub: 'I own a Renatural wig.\nLooking to add or ask questions.' }
          ].map(function(s) {
            var isSel = custStatus === s.id;
            return h('div', { key: s.id, className: 'rnss-status-card' + (isSel ? ' rnss-selected' : ''), onClick: function() { setCustStatus(s.id); } },
              h('span', { className: 'rnss-status-card-label' }, s.label),
              h('span', { className: 'rnss-status-card-sub' }, s.sub),
              h('div', { className: 'rnss-status-card-check' }, '\u2713')
            );
          })
        ),

        // What's on your mind — multi-select, correct order, title case
        h('span', { className: 'rnss-section-label' }, "What\u2019s on your mind?"),
        h('p', { style: { fontFamily: '\'DM Sans\', sans-serif', fontSize: 10, color: MUTED, fontStyle: 'italic', marginBottom: 10, marginTop: -6 } }, 'Select all that apply'),
        h('div', { className: 'rnss-pill-group' },
          MIND_OPTIONS.map(function(r) {
            var isSel = reasons.includes(r);
            return h('div', { key: r, className: 'rnss-pill' + (isSel ? ' rnss-selected' : ''), onClick: function() { toggleReason(r); } }, r);
          })
        )
      );
    }

    // ── Screen 2B: Aftercare details ────────────────────────────────────────
    function renderScreen2B() {
      return h('div', { className: 'rnss-screen' },
        h('button', { className: 'rnss-btn-back', onClick: back }, '\u2190 Back'),
        h('span', { className: 'rnss-section-label', style: { marginTop: 0 } }, 'Which wig do you have?'),
        h('div', { className: 'rnss-pill-group' },
          ['Gentle Wave', 'Deep Curl', 'Kinky Straight'].map(function(t) {
            return h('div', { key: t, className: 'rnss-pill' + (acTexture === t ? ' rnss-selected' : ''), onClick: function() { setAcTexture(acTexture === t ? null : t); } }, t);
          })
        ),
        h('div', { className: 'rnss-pill-group', style: { marginTop: 6 } },
          ['Natural Black', 'Chestnut Brown', 'Rooted Blonde'].map(function(t) {
            return h('div', { key: t, className: 'rnss-pill' + (acTone === t ? ' rnss-selected' : ''), onClick: function() { setAcTone(acTone === t ? null : t); } }, t);
          })
        ),
        h('span', { className: 'rnss-section-label' }, 'What do you need help with?'),
        h('div', { className: 'rnss-pill-group' },
          ['Install Walkthrough', 'Styling', 'Care & Maintenance', 'Something Else'].map(function(n) {
            return h('div', { key: n, className: 'rnss-pill' + (acNeed === n ? ' rnss-selected' : ''), onClick: function() { setAcNeed(acNeed === n ? null : n); } }, n);
          })
        ),
        h('span', { className: 'rnss-section-label' }, 'How long have you had it?'),
        h('div', { className: 'rnss-pill-group' },
          ['Just Got It', 'A Few Weeks', 'Several Months', 'Over a Year'].map(function(d) {
            return h('div', { key: d, className: 'rnss-pill' + (acDuration === d ? ' rnss-selected' : ''), onClick: function() { setAcDuration(acDuration === d ? null : d); } }, d);
          })
        )
      );
    }

    // ── Screen 3: Contact ──────────────────────────────────────────────────
    function renderScreen3() {
      if (isCasting) return renderScreen3Casting();
      return h('div', { className: 'rnss-screen' },
        h('button', { className: 'rnss-btn-back', onClick: back }, '\u2190 Back'),
        h('div', { className: 'rnss-field-row' },
          h('div', { className: 'rnss-field' },
            h('label', { className: 'rnss-field-label' }, 'First Name'),
            h('input', { className: 'rnss-input', type: 'text', placeholder: 'Your name', value: name, onChange: function(e) { setName(e.target.value); } })
          ),
          h('div', { className: 'rnss-field' },
            h('label', { className: 'rnss-field-label' }, 'Email'),
            h('input', { className: 'rnss-input', type: 'email', placeholder: 'your@email.com', value: email, onChange: function(e) { setEmail(e.target.value); } })
          )
        ),
        h('div', { className: 'rnss-field' },
          h('label', { className: 'rnss-field-label' }, 'Phone ', h('span', { className: 'rnss-field-optional' }, '(optional)')),
          h('input', { className: 'rnss-input', type: 'tel', placeholder: '+1 (000) 000-0000', value: phone, onChange: function(e) { setPhone(e.target.value); } })
        ),
        h('span', { className: 'rnss-section-label' }, 'Appointment format'),
        h('div', { className: 'rnss-mode-toggle' },
          [{ val: 'virtual', label: 'Virtual' }, { val: 'in-person', label: 'In Person' }].map(function(m) {
            return h('button', { key: m.val, className: 'rnss-mode-btn' + (apptMode === m.val ? ' rnss-selected' : ''), onClick: function() { setApptMode(m.val); } }, m.label);
          })
        ),
        apptMode === 'in-person' && h('div', { className: 'rnss-location-note' },
          h('span', null, '\uD83D\uDCCD'),
          h('span', { className: 'rnss-location-note-text' },
            h('strong', null, 'Brooklyn, New York.'), ' In-person appointments are held at our DUMBO studio. You\u2019ll receive the exact address in your confirmation email.'
          )
        ),
        h('div', { className: 'rnss-field' },
          h('label', { className: 'rnss-field-label' }, 'Anything we should know? ', h('span', { className: 'rnss-field-optional' }, '(optional)')),
          h('textarea', { className: 'rnss-textarea', placeholder: 'Questions, context, or anything helpful for your stylist\u2026', value: notes, onChange: function(e) { setNotes(e.target.value); } })
        )
      );
    }

    // ── Screen 3, casting: first, last, email, phone. Nothing else. ────
    function renderScreen3Casting() {
      function field(label, key, val, setter, type, ph) {
        return h('div', { className: 'rnss-field', key: key },
          h('label', { className: 'rnss-field-label' }, label),
          h('input', {
            className: 'rnss-input', type: type, placeholder: ph, value: val,
            onChange: function(e) { setter(e.target.value); }
          })
        );
      }
      return h('div', { className: 'rnss-screen' },
        h('button', { className: 'rnss-btn-back', onClick: back }, '\u2190 Back'),
        h('div', { className: 'rnss-field-row' },
          field('First Name', 'fn', name,     setName,     'text', 'First'),
          field('Last Name',  'ln', lastName, setLastName, 'text', 'Last')
        ),
        field('Email', 'em', email, setEmail, 'email', 'your@email.com'),
        field('Phone', 'ph', phone, setPhone, 'tel',   '+1 (000) 000-0000')
      );
    }

    // ── Calendar render — used in screen 4 ────────────────────────────────
    function renderCalendar() {
      var firstDay    = new Date(calYear, calMonth, 1).getDay();
      var daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
      var todayD = now.getDate(), todayM = now.getMonth(), todayY = now.getFullYear();
      var minDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);

      function prevMonth() {
        if (isCasting) return;
        if (calMonth === 0) { setCalMonth(11); setCalYear(calYear - 1); }
        else setCalMonth(calMonth - 1);
        setSelDay(null); setSelTime(null);
      }
      function nextMonth() {
        if (isCasting) return;
        if (calMonth === 11) { setCalMonth(0); setCalYear(calYear + 1); }
        else setCalMonth(calMonth + 1);
        setSelDay(null); setSelTime(null);
      }

      var cells = [];
      for (var i = 0; i < firstDay; i++) cells.push(null);
      for (var d = 1; d <= daysInMonth; d++) cells.push(d);

      var dateStr      = selDay ? formatDateStr(calYear, calMonth, selDay) : null;
      var currentSlots = dateStr ? (slots[dateStr] || []) : [];

      return h('div', { className: 'rnss-cal' },
        h('div', { className: 'rnss-cal-header' },
          isCasting ? h('span', { className: 'rnss-cal-nav', style: { opacity: 0.2, cursor: 'default' } }, '\u2039')
                    : h('button', { className: 'rnss-cal-nav', onClick: prevMonth }, '\u2039'),
          h('span', { className: 'rnss-cal-month' }, MONTHS[calMonth] + ' ' + calYear),
          isCasting ? h('span', { className: 'rnss-cal-nav', style: { opacity: 0.2, cursor: 'default' } }, '\u203a')
                    : h('button', { className: 'rnss-cal-nav', onClick: nextMonth }, '\u203a')
        ),
        h('div', { className: 'rnss-cal-grid' },
          DAYS.map(function(dow) { return h('div', { key: dow, className: 'rnss-cal-dow' }, dow); }),
          cells.map(function(day, idx) {
            if (!day) return h('div', { key: 'e' + idx, className: 'rnss-cal-day rnss-cal-day-empty' });
            var cellDate = new Date(calYear, calMonth, day);
            var dow      = cellDate.getDay();
            var isWeekend = dow === 0 || dow === 6;
            var isPast    = cellDate < minDate;
            var isToday   = calYear === todayY && calMonth === todayM && day === todayD;
            var isSel     = selDay === day;
            // Casting: only the four published dates are selectable.
            var unavail   = isCasting
              ? CASTING.dates.indexOf(formatDateStr(calYear, calMonth, day)) === -1
              : (isWeekend || isPast);
            var cls = 'rnss-cal-day' +
              (isSel   ? ' rnss-cal-day-selected' : '') +
              (unavail ? ' rnss-cal-day-unavail'  : '') +
              (isToday && !isSel ? ' rnss-cal-day-today' : '');
            return h('div', { key: day, className: cls,
              onClick: unavail ? null : function() { setSelDay(day); setSelTime(null); }
            }, day);
          })
        ),

        // Time slots — shown after date selected with scroll hint between
        selDay && h('div', null,
          // Scroll hint between calendar and times
          h('div', { className: 'rnss-scroll-hint' },
            h('div', { className: 'rnss-scroll-hint-dot' }),
            'Select a time below',
            h('div', { className: 'rnss-scroll-hint-dot' })
          ),
          h('span', { className: 'rnss-slot-label' }, 'Available times for ' + MONTHS[calMonth] + ' ' + selDay),
          slotsLoading
            ? h('div', { className: 'rnss-slots-loading' }, 'Loading availability\u2026')
            : currentSlots.length === 0
              ? h('div', { className: 'rnss-slots-empty' }, 'No availability on this date. Please choose another day.')
              : h('div', { className: 'rnss-slots' },
                  currentSlots.map(function(t) {
                    return h('button', { key: t, className: 'rnss-slot' + (selTime === t ? ' rnss-selected' : ''), onClick: function() { setSelTime(t); } }, t);
                  })
                )
        )
      );
    }

    // ── Screen 4: Calendar + time (own dedicated step) ─────────────────────
    function renderScreen4() {
      return h('div', { className: 'rnss-screen' },
        h('button', { className: 'rnss-btn-back', onClick: back }, '\u2190 Back'),
        isCasting ? renderCastingPicker() : renderCalendar()
      );
    }

    // ── Casting picker — four dates, four times, no month grid ───────
    // A 42-cell calendar to expose 4 dates forces scrolling on every
    // screen size. Two short columns fit above the fold everywhere.
    function renderCastingPicker() {
      var DOW = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

      var dateBtns = CASTING.dates.map(function(ds) {
        var parts = ds.split('-');
        var dt    = new Date(+parts[0], +parts[1] - 1, +parts[2]);
        var dayNo = dt.getDate();
        var on    = selDay === dayNo;
        return h('button', {
          key: ds,
          className: 'rnc-date' + (on ? ' rnc-on' : ''),
          onClick: function() { setSelDay(dayNo); setSelTime(null); }
        },
          h('span', { className: 'rnc-dow' },  DOW[dt.getDay()]),
          h('span', { className: 'rnc-dnum' }, MONTHS[dt.getMonth()] + ' ' + dayNo)
        );
      });

      var dateStr = selDay ? formatDateStr(calYear, calMonth, selDay) : null;
      var open    = dateStr ? (slots[dateStr] || []) : [];

      var timeCol;
      if (!selDay) {
        timeCol = h('div', { className: 'rnc-hint' }, 'Pick a day to see available times.');
      } else if (slotsLoading) {
        timeCol = h('div', { className: 'rnc-hint' }, 'Checking availability\u2026');
      } else {
        // Show every published slot; grey out the ones already taken so
        // the grid never collapses and the layout stays still.
        timeCol = CASTING.slots.map(function(t) {
          var free = open.indexOf(t) !== -1;
          return h('button', {
            key: t,
            className: 'rnc-time' + (selTime === t ? ' rnc-on' : ''),
            disabled: !free,
            title: free ? '' : 'Already booked',
            onClick: free ? function() { setSelTime(t); } : null
          }, t);
        });
      }

      return h('div', { className: 'rnc-pick' },
        h('div', { className: 'rnc-col rnc-col-dates' },
          h('span', { className: 'rnc-lbl' }, 'Choose a day'),
          dateBtns
        ),
        h('div', { className: 'rnc-col rnc-col-times' },
          h('span', { className: 'rnc-lbl' }, 'Choose a time'),
          timeCol
        )
      );
    }

    // ── Screen 5: Review + Pay ─────────────────────────────────────────────
    function renderScreen5() {
      var dateStr   = formatDateStr(calYear, calMonth, selDay);
      var dayOfWeek = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][new Date(calYear, calMonth, selDay).getDay()];
      var formatStr = dayOfWeek + ', ' + MONTHS[calMonth] + ' ' + selDay + ' at ' + selTime;
      var isFree    = FREE_TYPES.indexOf(apptType) !== -1;
      var typeLabel = apptType === 'casting'      ? 'Model Casting Audition'
                    : apptType === 'consultation' ? 'Pre-Purchase Consultation'
                    :                               'Aftercare Consultation';
      var modeLabel = isFree ? CASTING.location + ' \u00b7 ' + CASTING.durationLabel
                    : apptMode === 'in-person' ? 'In Person, DUMBO, Brooklyn' : 'Virtual';

      return h('div', { className: 'rnss-screen' },
        h('button', { className: 'rnss-btn-back', onClick: back }, '\u2190 Back'),
        h('div', { className: 'rnss-pay-block' },
          [
            ['Appointment', typeLabel],
            ['Date & Time', formatStr],
            ['Format',      modeLabel],
            ['Name',        fullName()],
            ['Email',       email],
          ].map(function(row) {
            return h('div', { key: row[0], className: 'rnss-pay-row' },
              h('span', { className: 'rnss-pay-key' }, row[0]),
              h('span', { className: 'rnss-pay-val' }, row[1])
            );
          }),
          isFree ? null : h('div', { className: 'rnss-pay-row' },
            h('span', { className: 'rnss-pay-key' }, 'Total'),
            h('span', { className: 'rnss-pay-total' }, '$50.00')
          )
        ),
        h('p', { className: 'rnss-pay-note' }, isFree
          ? 'No payment required. Your slot is held as soon as you confirm. A calendar invite and confirmation email follow immediately.'
          : 'Payment is required to hold your appointment. You\u2019ll receive a Google Calendar invite and confirmation email after checkout. The $50 is credited toward your wig order.'),
        h('button', {
          className: 'rnss-btn-primary',
          disabled: submitting,
          onClick: isFree ? handleDirectBook : handleCheckout,
          style: { width: '100%' }
        }, submitting
             ? (isFree ? 'Booking\u2026' : 'Redirecting\u2026')
             : (isFree ? 'Confirm Booking \u2192' : 'Pay $50 \u2192 Checkout'))
      );
    }

    function renderFooter() {
      if (screen === 6 || screen === 5) return h('div', { className: 'rnss-footer' }, h('span', { className: 'rnss-step-count' }, 'Step ' + stepNum + ' of ' + totalSteps));
      return h('div', { className: 'rnss-footer' },
        h('span', { className: 'rnss-step-count' }, 'Step ' + stepNum + ' of ' + totalSteps),
        h('button', {
          className: 'rnss-btn-primary',
          disabled: !canAdvance(),
          onClick: advance
        }, 'Continue \u2192')
      );
    }

    var screenContent = (function() {
      if (screen === 1)    return renderScreen1();
      if (screen === '2a') return renderScreen2A();
      if (screen === '2b') return renderScreen2B();
      if (screen === '2c') return renderScreen2C();
      if (screen === '2d') return renderScreen2D();
      if (screen === 3)    return renderScreen3();
      if (screen === 4)    return renderScreen4();
      if (screen === 5)    return renderScreen5();
      if (screen === 6)    return renderScreen6();
      return null;
    })();

    return h('div', { className: 'rnss-overlay' + (visible ? ' rnss-visible' : ''), onClick: handleClose },
      h('div', { className: 'rnss-modal', onClick: function(e) { e.stopPropagation(); } },
        h('button', { className: 'rnss-close', onClick: handleClose }, '\u00d7'),
        renderProgress(),
        renderHeader(),
        h('div', { className: 'rnss-body', ref: bodyRef }, screenContent),
        renderFooter()
      )
    );
  }

  var _mountEl   = null;
  var _reactRoot = null;

  function renderScheduler(initialType) {
    if (!_mountEl) {
      _mountEl = document.createElement('div');
      _mountEl.id = 'rnss-root';
      document.body.appendChild(_mountEl);
      var style = document.createElement('style');
      style.id = 'rnss-styles';
      style.textContent = css;
      document.head.appendChild(style);
    }
    function unmount() {
      if (_reactRoot) { _reactRoot.render(null); }
      else if (_mountEl) { ReactDOM.unmountComponentAtNode(_mountEl); }
    }
    var el = React.createElement(Scheduler, { initialType: initialType || null, onClose: unmount });
    if (ReactDOM.createRoot) {
      if (!_reactRoot) _reactRoot = ReactDOM.createRoot(_mountEl);
      _reactRoot.render(el);
    } else {
      ReactDOM.render(el, _mountEl);
    }
  }

  window.openScheduler = function(type) { renderScheduler(type || null); };

})();